import { FC } from 'react';
import FDFApplied from './FDFApplied';
import LoanApplicationProcessLayout from 'ui/components/LoanApplicationProcessLayout';

const FDFAppliedScene: FC = () => {
  return (
    <LoanApplicationProcessLayout>
      <FDFApplied />
    </LoanApplicationProcessLayout>
  );
};

export default FDFAppliedScene;
